import { Grid } from "fashion/fabrics";
import BlogCard from "nodes/blog/BlogCard";
import useBlogPosts from "gears/blog/useBlogPosts";
import { reverse } from "books/reflow";

const BlogCardCarousel = () => {
  const { blogPosts } = useBlogPosts();
  return (
    <Grid container rowSpacing={2} columnSpacing={2} justifyContent="center">
      {reverse(blogPosts).map((post, index) => (
        <Grid size={{ xs: 12, sm: 6, md: 4, lg: 4 }} key={index}>
          <BlogCard post={post} />
        </Grid>
      ))}
    </Grid>
  );
};

export default BlogCardCarousel;
